<template>
	<div class="work-show-page">
		<div class="header-bar">
			<span class="title-icon">🖼️</span>
			<span class="title-text">作品展示</span>
		</div>

		<div class="tab-group">
			<div class="tab-item" :class="{ active: activeTab === 'myWork' }" @click="foractiveTab('myWork')">
				我的作品
			</div>
			<div class="tab-item" :class="{ active: activeTab === 'excellent' }" @click="foractiveTab('excellent')">
				优秀案例
			</div>
		</div>

		<div class="loading-container" v-if="loading">
			<div class="loading-spinner"></div>
			<p class="loading-text">加载中...</p>
		</div>

		<div class="work-list" v-else>
			<div class="work-card" v-for="item in List" :key="item.id">
				<div class="card-img-box">
					<img :src="item.imgSrc" alt="作品图" class="work-img" @click="openPreview(item)" />
					<div class="like-btn" @click="userType == 3 && toggleLike(item)"
						:class="{ disabled: userType != 3 }">
						<span class="like-icon">{{ item.isLike ? '❤️' : '🤍' }}</span>
						<span class="like-count" :class="{active: item.isLike}">{{ item.likeCount }}</span>
					</div>
					<div class="score-box">{{ item.score }}分</div>
					<div class="card-header" @click="getFileAiContent(item)">
						<span class="type-icon" :class="{ design: item.type === 'design' }">
							<img v-if="toImage(item.imgType)" :src="isImage(item.imgType)" class="tab-icon">
							<!-- Emoji图标：完美垂直居中 -->
							<span v-else class="tab-emoji">{{ isImage(item.imgType) }}</span>
						</span>
					</div>
				</div>
				<p class="date-text">{{ item.date }}</p>
				<p class="date-text">{{ item.studentName||'' }}</p>
			</div>
			<div v-if="total>pageNum" class="load-more-card">
				<button class="load-more-btn" :disabled="loadingMore" @click="forPange">
					{{ loadingMore ? '加载中...' : `加载更多（${pageNum}/${total}）` }}
				</button>
			</div>
		</div>
		<el-dialog title="🍭 评价表 🍭" :visible.sync="isFileTest" width="580px" @close="isFileTest = false"
			class="kid-dialog" style="z-index: 3002;align-items: center;" :modal="false" :modal-append-to-body="false">
			<el-table :data="fullContent || []" border stripe style="width:100%; border-radius:16px; overflow:hidden;"
				height="360" class="kid-table" header-row-class-name="kid-table-header" row-class-name="kid-table-row">
				<el-table-column label="评价维度" prop="name" align="center" />
				<el-table-column label="表现" prop="value" align="center">
					<template slot-scope="scope">
						<div v-html="forHtml(scope.row.value)"></div>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="success" round @click="isFileTest = false">✅ 关闭</el-button>
			</div>
		</el-dialog>
		<div class="img-preview-mask" v-if="showPreview" @mousewheel.prevent="handleWheel">
			<div class="img-wrapper" :style="{ transform: `translate(${posX}px, ${posY}px) scale(${scale})` }"
				@mousedown="startDrag" @mousemove="onDrag" @mouseup="endDrag" @mouseleave="endDrag">
				<img :src="previewImg" class="preview-img" @click.stop />
			</div>
			<div class="close-area" @click="closePreview"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "WorkShowPage",
		props: {
			courseClassId: {
				type: String,
				default: "0"
			},
			studentId: {
				type: String,
				default: ""
			},
		},
		data() {
			return {
				loading: false,
				activeTab: "myWork",
				userType: localStorage.getItem('userType'),
				List: [],
				isSave: localStorage.getItem('isSave') || false,
				uploadArr: {},
				isFileTest: false,
				fullContent: [],
				login:null,
				loadingMore:false,
				pageSize:10,
				pageNum:1,
				total:0,
				showPreview:false,
				previewImg:"",
				scale: 1,
				posX: 0,
				posY: 0,
				dragStartX: 0,
				dragStartY: 0,
				isDragging:false,
			};
		},
		mounted() {
			this.info()
			if (this.studentId != '') {
				this.List=[]
				this.loginOpen('作品加载中...')
				setTimeout(() => {
					
					this.activeTab = 'myWork'
					this.getCallbackList()
				}, 100);
			}
		},
		methods: {
			handleWheel(e) {
				const delta = e.deltaY || e.detail;
				if (delta > 0) {
					this.scale = Math.max(0.5, this.scale - 0.1);
				} else {
					this.scale = Math.min(3, this.scale + 0.1);
				}
			},
			forPange(){
				if(this.total>this.pageNum && !this.loadingMore){
					this.loadingMore = true
					this.pageNum=this.pageNum+1
					this.loginOpen('作品加载中...')
					this.getCallbackList()
				}
			},
			async getFileAiContent(val) {

				// if (this.userType != 2) return
				let list = []
				let score = 0;
				try {
					let res = await this.API.get(this.API.school.getFirstChatTest,{
						schoolId:localStorage.getItem('orgId'),
						id:val.id
					})
					if (res?.data?.data) {

						let fullContent = JSON.parse(res.data.data)

						Object.keys(fullContent).forEach(key => {
							list.push({
								"name": key,
								"value": fullContent[key]
							});
							if (key === '总分') score = fullContent[key];
						});
						console.log('list', list)
						this.fullContent = list
						this.isFileTest = true
					} else {
						this.$message.success('记录异常')
					}

				} catch (error) {

				}
			},
			openPreview(item) {
				console.log('item',item)
				this.previewImg = item.imgSrc;
				this.showPreview = true;
				this.scale = 1;
				this.posX = 0;
				this.posY = 0;
			},
			closePreview() {
				this.showPreview = false;
				this.previewImg = "";
			},
			startDrag(e) {
				this.isDragging = true;
				this.dragStartX = e.clientX - this.posX;
				this.dragStartY = e.clientY - this.posY;
			},
			onDrag(e) {
				if (!this.isDragging) return;
				this.posX = e.clientX - this.dragStartX;
				this.posY = e.clientY - this.dragStartY;
			},
			endDrag() {
				this.isDragging = false;
			},
			forHtml(val) {
				console.log('val', val)
				if (!val) return ''
				if (val.toString().indexOf('\n') > -1) {
					val = val.replace(/\n/g, "<br/>")
					const reg = /\*\*(.*?)\*\*/g;
					// 替换加粗
					val = val.replace(reg, '<strong>$1</strong>');
				}
				return val

			},
			toImage(val) {
				var arr = this.uploadArr.scoreItems[val - 1]
				if (arr.icon.startsWith("http")) {
					return true
				}
				return false
			},
			isImage(val) {
				var arr = this.uploadArr.scoreItems[val - 1]

				return arr.icon
			},
			async info() {
				try {
					let parmsString = localStorage.getItem('parms')
					let parms = JSON.parse(parmsString)
					this.uploadArr = parms.upload
					console.log('this.parms', this.uploadArr)
					this.activeTab = this.uploadArr.scoreItems[0].key
				} catch (error) {

				}
			},
			foractiveTab(type) {

				this.loginOpen('作品加载中...')
				this.pageNum=1
				this.total=0
				this.activeTab = type
				this.List = []
				if (this.studentId != '') {
					setTimeout(() => {
						this.getCallbackList()
					}, 100);
				}
			},
			getFullTime(timestamp) {
				if (!timestamp) return ''
				const t = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
				const d = new Date(t)
				const y = d.getFullYear()
				const m = String(d.getMonth() + 1).padStart(2, '0')
				const day = String(d.getDate()).padStart(2, '0')
				const h = String(d.getHours()).padStart(2, '0')
				const mi = String(d.getMinutes()).padStart(2, '0')
				const s = String(d.getSeconds()).padStart(2, '0')
				return `${y}-${m}-${day} ${h}:${mi}:${s}`
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			// 2026-07-28 我的作品分页：兼容 content/records/list，并按作品 id 去重合并。
			getWorkPageData(data) {
				if (!data) return {}
				if (data.data && typeof data.data === 'object') return data.data
				return data
			},
			getWorkRecords(pageData) {
				if (Array.isArray(pageData)) return pageData
				const records = pageData.content || pageData.records || pageData.list || pageData.rows
				return Array.isArray(records) ? records : []
			},
			getWorkTotalPages(pageData) {
				if (pageData.totalPages !== undefined) return Number(pageData.totalPages) || 0
				if (pageData.pages !== undefined) return Number(pageData.pages) || 0
				if (pageData.totalPage !== undefined) return Number(pageData.totalPage) || 0
				if (pageData.total !== undefined) return Math.ceil((Number(pageData.total) || 0) / this.pageSize)
				return 0
			},
			mergeWorkList(oldList, newList) {
				const used = new Set()
				const result = []
				const pushItem = (item) => {
					const key = item && item.id
					if (key !== undefined && key !== null && used.has(key)) return
					if (key !== undefined && key !== null) used.add(key)
					result.push(item)
				}
				oldList.forEach(pushItem)
				newList.forEach(pushItem)
				return result
			},
			async getCallbackList() {
				
				try {
					const res = await this.API.get(this.API.school.getLikePage, {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						schoolId: localStorage.getItem("orgId"),
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						// imgType:'',
						isCase: this.activeTab == 'myWork' ? null : 1
					});
					let studentImgList = []
					if (this.activeTab == 'myWork') {
						if (localStorage.getItem('studentImgList')) {
							studentImgList = JSON.parse(localStorage.getItem('studentImgList'))
						}
					} else {
						if (localStorage.getItem('classImgList')) {
							studentImgList = JSON.parse(localStorage.getItem('classImgList'))
						}
					}
					
					const pageData = this.getWorkPageData(res.data)
					const list = this.getWorkRecords(pageData);
					this.total = this.getWorkTotalPages(pageData)
					const tasks = list.map(async (item) => {
						const newItem = {
							...item
						};
						newItem.date =this.getFullTime(item.createTime) 
						const likeList = Array.isArray(newItem.likeList) ? newItem.likeList : []
						newItem.isLike = likeList.filter(v => v.studentId == this.studentId).length;
						newItem.likeCount=likeList.length
						var arr = studentImgList.find(v => v.id == newItem.id)
						if (arr && arr.imgSrc) {
							newItem.imgSrc = arr.imgSrc
						} else if (newItem.content) {
							try {
								newItem.imgSrc = await this.$oss.getDownloadUrl(newItem.content);
							} catch (e) {
								newItem.imgSrc = "";
							}
						} else {
							newItem.imgSrc = "";
						}
						return newItem;
					});

					const newList = await Promise.all(tasks);
					this.List = this.mergeWorkList(this.List, newList)
					if (this.activeTab == 'myWork') {
						localStorage.setItem('studentImgList', JSON.stringify(this.List))
					} else {
						localStorage.setItem('classImgList', JSON.stringify(this.List))
					}
					
					this.noLogin()
						
				} catch (err) {
					console.error('获取失败', err);
					this.noLogin()
				} finally {
					this.loadingMore = false
				}
			},
			
			async toggleLike(item) {
				const oldStatus = item.isLike;
				item.isLike = !oldStatus;

				if (item.isLike) {
					item.likeCount++;
				} else {
					item.likeCount--;
				}

				try {
					await this.API.post(this.API.school.postSaveOrUpdate, {
						fileRecordId: item.id,
						studentId: this.studentId,
						status: item.isLike ? 1 : 0,
						schoolId:localStorage.getItem('orgId')
					});
				} catch (err) {
					item.isLike = oldStatus;
					item.likeCount += item.isLike ? -1 : 1;
					console.log("点赞接口异常");
				}
			}
		}
	};
</script>

<style scoped>
	.work-show-page {
		height: calc(100vh - 80px);
		width: 100%;
		background-color: #fff9e6;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.header-bar {
		height: 70px;
		flex-shrink: 0;
		background-color: #c5e1a5;
		color: #8b5a2b;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		font-size: 26px;
		font-weight: bold;
		border-bottom-left-radius: 20px;
		border-bottom-right-radius: 20px;
	}

	.title-icon {
		font-size: 28px;
	}

	.title-text {
		font-size: 26px;
	}

	.tab-group {
		display: flex;
		background: #fff;
		margin: 10px 16px;
		border-radius: 12px;
		padding: 4px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
		flex-shrink: 0;
	}

	.tab-item {
		flex: 1;
		text-align: center;
		padding: 10px 0;
		border-radius: 8px;
		font-size: 16px;
		color: #666;
		cursor: pointer;
	}

	.tab-item.active {
		background-color: #c5e1a5;
		color: #8b5a2b;
		font-weight: bold;
	}

	.loading-container {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 16px;
	}

	.loading-spinner {
		width: 50px;
		height: 50px;
		border: 5px solid #e0f2d9;
		border-top-color: #8bc34a;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	.loading-text {
		font-size: 20px;
		color: #666;
	}

	/* ========== 核心改动：自适应布局 ========== */
	.work-list {
		flex: 1;
		padding: 10px;
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
		grid-auto-rows: 180px;
		gap: 12px;
		overflow-y: auto;
		justify-items: center;
	}

	.work-card {
		background: #fff;
		border-radius: 16px;
		overflow: hidden;
		width: 100%;
		max-width: 150px;
		height: 180px;
		display: flex;
		flex-direction: column;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
	}

	/* 2026-07-28 我的作品分页样式：加载更多独立成整行按钮，不再伪装成作品图片卡片。 */
	.load-more-card {
		grid-column: 1 / -1;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 6px 0 12px;
	}

	.load-more-btn {
		min-width: 150px;
		height: 38px;
		padding: 0 18px;
		border: 0;
		border-radius: 19px;
		background: #8bc34a;
		color: #fff;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		box-shadow: 0 6px 14px rgba(139, 195, 74, .28);
	}

	.load-more-btn:disabled {
		cursor: not-allowed;
		opacity: .65;
	}

	.card-img-box {
		width: 100%;
		height: 140px;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
	}

	.work-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		cursor: pointer;
	}


	.card-header {
		position: absolute;
		top: 8px;
		left: 8px;
		z-index: 2;
	}

	.type-icon {
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #fff;
		border-radius: 50%;
		font-size: 16px;
	}

	.type-icon img {
		width: 30px;

	}

	.type-icon.design {
		background-color: #c5e1a5;
	}

	/* 点赞按钮 */
	.like-btn {
		position: absolute;
		left: 8px;
		bottom: 8px;
		z-index: 3;
		background: rgba(255, 255, 255, 0.9);
		border-radius: 20px;
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 2px 8px;
		cursor: pointer;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	}

	.like-btn.disabled {
		pointer-events: none;
		opacity: 0.6;
	}

	.like-icon {
		font-size: 14px;
	}

	.like-count {
		font-size: 14px;
		color: #666;
	}

	.like-count.active {
		color: #ff4444;
	}

	/* 分数 */
	.score-box {
		position: absolute;
		right: 8px;
		bottom: 8px;
		z-index: 3;
		background: rgba(51, 51, 51, 0.8);
		color: #fff;
		padding: 2px 6px;
		border-radius: 12px;
		font-size: 12px;
	}

	.date-text {
		padding: 1px 8px;
		font-size: 12px;
		color: #999;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.img-preview-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.85);
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.img-wrapper {
		transition: transform 0.1s ease;
		cursor: grab;
	}
	
	.img-wrapper:active {
		cursor: grabbing;
	}
	
	.preview-img {
		max-width: 90vw;
		max-height: 90vh;
		object-fit: contain;
		user-select: none;
		pointer-events: none;
	}
	.close-area {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
	}
	
	.type-icon img {
		width: 30px;
	
	}
</style>
